export const quadrants = ["SE", "NE", "NW", "SW"];
